module.exports = __webpack_public_path__ + "img/control-4-760.ff9dcf5.jpg";